module.exports = __webpack_public_path__ + "static/media/72.de4ec61e.jpg";